const topMain = () => {

  const pageTop = (document.getElementById("pageTop") != null);
  console.log(pageTop);
  if (pageTop) {

    const jsSecMain = document.getElementById('jsSecMain');
    const mainSwiper = jsSecMain.querySelector('.js-swiper');

    const swiper = new Swiper(mainSwiper, {
      // slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      speed: 2000,
      autoplay: {
        delay: 6000,
        stopOnLastSlide: true,
        disableOnInteraction: false,
        waitForTransition: true,
      },
      allowTouchMove: false,
      followFinger: false,
      on: {
        transitionStart: function(){
        },
        transitionEnd: function(){
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

  }

}
export default topMain;